import {
	GET_LIST,
	GET_ONE,
	GET_MANY,
	GET_MANY_REFERENCE,
	CREATE,
	UPDATE,
	UPDATE_MANY,
	DELETE,
	DELETE_MANY,
} from 'react-admin';
import { Parse } from 'parse';
import { addTradeUnion } from './TradeUnion';
import { clearConfirmationMessage } from './UserProfile';


export const handlers = [
	addTradeUnion,
	clearConfirmationMessage,
];

export const dataProviderExtension = (requestHandler) => {
	const innerHandler = (type, resource, params) => {
		// eslint-disable-next-line no-restricted-syntax
		for (const handler of handlers) {
			const result = handler(requestHandler)(type, resource, params);

			if (result) return result;
		}

		return requestHandler(type, resource, params);
	};
	return {
		getList: (r, p) => innerHandler(GET_LIST, r, p),
		getOne: (r, p) => innerHandler(GET_ONE, r, p),
		getMany: (r, p) => innerHandler(GET_MANY, r, p),
		getManyReference: (r, p) => innerHandler(GET_MANY_REFERENCE, r, p),
		create: (r, p) => innerHandler(CREATE, r, p),
		update: (r, p) => innerHandler(UPDATE, r, p),
		updateMany: (r, p) => innerHandler(UPDATE_MANY, r, p),
		delete: (r, p) => innerHandler(DELETE, r, p),
		deleteMany: (r, p) => innerHandler(DELETE_MANY, r, p),
		runCloudFunction: (functionName, params) => (
			Parse.Cloud.run(functionName, params)
				.then((result) => {
					if (!result || !(result instanceof Object) || !Object.hasOwn(result, 'data')) {
						return { data: result };
					}
					return result;
				})),
	};
};

